import { useState } from 'react'
import { Shirt } from 'lucide-react'
import type { Product } from '@/types'
import { cn } from '@/lib/cn'

/** Product photo with graceful fallback to the colored garment icon. */
export default function ProductImage({
  product,
  className,
}: {
  product: Pick<Product, 'name' | 'image_url' | 'image_color'>
  className?: string
}) {
  const [broken, setBroken] = useState(false)
  const showImage = product.image_url && !broken

  return (
    <div
      className={cn('flex items-center justify-center overflow-hidden rounded-lg', className)}
      style={showImage ? undefined : { backgroundColor: (product.image_color ?? '#1e3a8a') + '22' }}
    >
      {showImage ? (
        <img
          src={product.image_url!}
          alt={product.name}
          className="size-full object-cover"
          onError={() => setBroken(true)}
        />
      ) : (
        <Shirt className="size-1/3" style={{ color: product.image_color ?? '#1e3a8a' }} />
      )}
    </div>
  )
}
